import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { Row } from 'shared/mui/Row/Row';
import { Typography } from 'shared/mui/Typography';
import { useImportActions } from 'shared/widgets/RequestsBankOpsImport/RequestsBankOpsImportResultDialog/hooks/useImportActions';
import { RequestsBankOpsImportResultDialogSkeleton } from 'shared/widgets/RequestsBankOpsImport/RequestsBankOpsImportResultDialog/RequestsBankOpsImportResultDialogSkeleton';
import { ImportFile } from 'types/embedded/bankOperation';

type Props = {
  open: boolean;
  onClose: () => void;
  activeImport: ImportFile | undefined;
  errors: string[];
  isLoadingErrors: boolean;
  onSuccess?: (file: ImportFile) => void;
};

const LIMIT_ERRORS = 5;

export const RequestsBankOpsImportResultDialog: React.FC<Props> = ({
  open,
  errors,
  isLoadingErrors,
  activeImport,
  onClose,
  onSuccess,
}) => {
  const { handleApprove, handleReject, isApproving, isRejecting } = useImportActions({
    activeImport,
    onSuccess,
    onClose,
  });
  const isLoading = isApproving || isRejecting;

  return (
    <Dialog onClose={() => undefined} open={open} width="640px">
      <CardHeader title="Результаты проверки файла" titleSize="smallBold" />
      <CardContent>
        <Box>
          <Row>
            <Typography variant="body1">Всего строк:</Typography>
            <Typography>{activeImport?.totalRows}</Typography>
          </Row>
          <Row>
            <Typography variant="body1">
              Количество корректных строк, которые могут быть загружены:
            </Typography>
            <Typography>{activeImport?.validRows}</Typography>
          </Row>
          <Row>
            <Typography variant="body1">Количество строк с ошибками:</Typography>
            <Typography>{activeImport?.errorRows}</Typography>
          </Row>
        </Box>
        {isLoadingErrors && <RequestsBankOpsImportResultDialogSkeleton />}
        {errors.length > 0 && (
          <Box>
            <Typography fontWeight={500} mt={3} variant="body1">
              Список строк с ошибками:
            </Typography>
            <Box lang="ru">
              {errors.slice(0, LIMIT_ERRORS).map((error, index) => {
                return (
                  <Typography
                    key={index}
                    sx={{
                      overflowWrap: 'break-word',
                      wordBreak: 'normal',
                      hyphens: 'auto',
                      maxWidth: '100%',
                    }}
                  >
                    {error}
                  </Typography>
                );
              })}
            </Box>
            {errors.length > LIMIT_ERRORS && (
              <Typography fontWeight={500} mt={3} variant="body1">
                Полный отчёт с ошибками будет доступен для скачивания после выбора действия в этом
                окне.
              </Typography>
            )}
          </Box>
        )}
      </CardContent>
      <CardActionsButtons
        rightActionsSlot={[
          <Button
            disabled={isLoading}
            isLoading={isRejecting}
            key="cancel"
            label="Отменить загрузку"
            onClick={handleReject}
            variant="outlined"
          />,
          <Button
            disabled={isLoading}
            isLoading={isApproving}
            key="create"
            label="Загрузить корректные строки"
            onClick={handleApprove}
            variant="contained"
          />,
        ]}
      />
    </Dialog>
  );
};
